













































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Estacao } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { DataOptions } from 'vuetify'
import { Page } from '@/models'
import { Pageable } from '@/models/Pageable'
import axios, { CancelTokenSource } from 'axios'
import { ObserveVisibility } from 'vue-observe-visibility'
import { FindEstacaoUseCase, SaveEstacaoUseCase} from '@/usecases'

@Component({
	model: {
		prop: 'estacao',
	},
	directives: {
		ObserveVisibility,
	},
})
export default class SeletorDeEstacao extends Vue {
	@Prop({ type: [Object, Array], default: null }) estacao!: (string | Estacao) | (string | Estacao)[] | null
	@Prop({ type: Boolean }) podeCriar!: boolean
	@Prop({ type: Boolean }) podeEditar!: boolean
	@Prop({ type: Boolean }) returnObject!: boolean
	@Prop({ type: Boolean }) multiple!: boolean
	busca = ''
	itemEditando: null | ItemSelecao = null
	itensSelecao: ItemSelecao[] = []
	findEstacaoUseCase = new FindEstacaoUseCase()
	saveEstacaoUseCase = new SaveEstacaoUseCase()

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	pagina: Page<Estacao> | null = null

	cancelToken: CancelTokenSource | null = null

	buscandoMaisItens = false
	buscandoNovosItens = true

	created() {
		this.buscarNovosItens()
	}

	marcaEmItemAutocompletar(estacao: Estacao | string): ItemSelecao {
		return typeof estacao === 'string'
			? {
				id: '',
				nome: estacao,
				tipo: 'selecao',
			}
			: {
				...estacao,
				tipo: 'selecao',
			}
	}

	get itens() {
		let itens: ItemAutocompletar[] = this.estacao === null
			? []
			: (Array.isArray(this.estacao)
				? this.estacao.map(this.marcaEmItemAutocompletar)
				: [this.marcaEmItemAutocompletar(this.estacao)])

		itens = [
			...itens,
			...this.podeCriar
				? [{
					tipo: 'header',
					header: 'Selecione uma opção ou crie uma',
				} as ItemHeader]
				: [],
			...this.itensSelecao,
		]
		if (this.pagina && !this.pagina.last && !this.buscandoNovosItens)
			itens.push({ tipo: 'buscar-mais' })

		const estacoes = this.estacao
		if (!this.podeCriar || !this.busca || this.buscandoNovosItens) return itens
		if (!estacoes) return [{ tipo: 'novo' }, ...itens]
		if (Array.isArray(estacoes)) {
			return estacoes.some(
				estacao => this.busca.toLowerCase() === this.obterNomeEstacao(estacao).toLowerCase(),
			)
				? itens
				: [{ tipo: 'novo' }, ...itens]
		}
		return this.busca.toLowerCase() === this.obterNomeEstacao(estacoes).toLowerCase()
			? itens
			: [{ tipo: 'novo' }, ...itens]
	}

	obterNomeEstacao(estacao: Estacao | string) {
		return typeof estacao === 'string'
			? estacao
			: estacao.nome
	}

	async selecionaItem(item: ItemSelecao | ItemNovo) {
		if (!item) {
			this.$emit('input', null)
			return
		}

		if (item.tipo === 'novo') {
			await this.criarEstacao()
		} else {
			this.$emit('input', item)
		}
	}

	async criarEstacao() {
		try {
			if (this.busca.trim() == '') return AlertModule.setError("Não pode ser vazio")
			const estacaoNovo: Estacao = { id: '', nome: this.busca.trim() }

			const estacaoCriada = await this.saveEstacaoUseCase.create(estacaoNovo)

			const item: ItemSelecao = { ...estacaoCriada, tipo: 'selecao' }
			this.itensSelecao.push(item)
			this.emitirInput(item)

			return estacaoCriada
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	emitirInput(item: ItemSelecao) {
		if (!Array.isArray(this.estacao)) {
			this.$emit('input', this.returnObject
				? item
				: item.id,
			)
		} else {
			const estacoes = this.estacao || []
			this.$emit('input', [
				...estacoes,
				item,
			])
		}
	}

	editar(item) {
		this.itemEditando = { ...item }
	}

	async confirmarEdicao() {
		if (!this.itemEditando) {
			return
		}
		if (!this.itemEditando.nome) {
			this.itemEditando = null
			return
		}
		const indice = this.itensSelecao.findIndex(
			item => item.id === this.itemEditando?.id,
		)
		if (indice === -1) return

		this.itensSelecao.splice(indice, 1, this.itemEditando)
		const estacaoEditado = {
			id: this.itemEditando.id,
			nome: this.itemEditando.nome,
		}
		await this.saveEstacaoUseCase.update(estacaoEditado)
		this.itemEditando = null
	}

	filtrar(item: ItemAutocompletar, queryText, itemText) {
		if (item.tipo === 'header') return false

		const hasValue = val => (val ? val : '')
		const textLower = hasValue(itemText).toString().toLowerCase()
		const queryLower = hasValue(queryText).toString().toLowerCase()

		if (item.tipo === 'novo') {
			return (
				queryLower &&
				!this.itensSelecao.some(({ nome }) => nome.toLowerCase() === queryLower)
			)
		}
		if (item.tipo === 'buscar-mais') return this.pagina && !this.pagina.last
		return textLower.includes(queryLower)
	}

	async buscar(paginavel: Pageable = {}): Promise<Estacao[]> {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.pagina = await this.findEstacaoUseCase.findAll({
				busca: this.busca || undefined,
				page: paginavel.page || 0,
				size: paginavel.size || 10,
				sort: 'nome',
			}, axiosConfig);
			this.paginacao.page = this.pagina.number
			return this.pagina.content
		} catch (e) {
			if (axios.isCancel(e)) throw e
			AlertModule.setError(e)
			throw e
		}
	}

	async buscarNovosItens() {
		this.buscandoNovosItens = true
		const estacoes = await this.buscar({
			...this.paginacao,
			page: 0,
		})
		this.itensSelecao = []
		this.inserirEstacoes(estacoes)
		this.buscandoNovosItens = false
	}

	async buscarMaisItens() {
		this.buscandoMaisItens = true
		const estacoes = await this.buscar({
			...this.paginacao,
			page: this.paginacao.page + 1,
		})
		this.inserirEstacoes(estacoes)
		this.buscandoMaisItens = false
	}

	inserirEstacoes(estacoes: Estacao[]) {
		this.itensSelecao = [
			...this.itensSelecao,
			...estacoes.map<ItemSelecao>(item => ({
				...item,
				tipo: 'selecao',
			})),
		]
	}

	@Watch('busca')
	onChangeBusca = this.buscarNovosItens

	mudouVisibilidade(visivel) {
		if (visivel && !this.buscandoMaisItens) this.buscarMaisItens()
	}
}

export type ItemHeader = {
	tipo: 'header'
	header: string
}

export type ItemSelecao = Estacao & {
	tipo: 'selecao'
}

export type ItemNovo = {
	tipo: 'novo'
	text: string
}

export type ItemBuscarMais = {
	tipo: 'buscar-mais'
}

export type ItemAutocompletar = ItemHeader | ItemSelecao | ItemNovo | ItemBuscarMais
